import { decodeBase64ToFile, formatSteps, getMimeTypeFromFileName } from "utils/reportGenerator";

const defaultState: any = {
        reportInfo : {
            reportId: null,
            reportMode: "edit",
            isLatestVersion: true,
        },
        findings: [],
        error: false,
        loading: false,
        isEdit: false,
        isReportCreated: false,
        isFindingCreated: false,
        vul_category_list: [],
        isFindingGenerated: false,
        vul_name_list: {},
        isVulNameAdded: false,
        isGetVulCatLoaded: false,
        isReportGenerated: false,
        errorGenerateReport: false,
        errorMessage: '',
        stepUploadError: false,
        stepDeleteError: false,
        isVulCategroryNameChanged: false,
};

const sideBarReducer = (state = defaultState, action: any) => {
    switch (action.type) {
        case 'SET_SIDEBAR_COLLAPSED':
            return { ...state, collapsed: action.payload };
        case 'CREATE_REPORT_STARTED':
            return { ...state, loading: true ,error:false, errorMessage:''};
        case 'CREATE_REPORT_COMPLETED': 
            return {...state, 
                findings: [],
                reportInfo: {
                    reportId: action.payload?.report_id,
                    reportName: action.payload?.reportName,
                    clientName: action.payload?.clientName,
                    applicationName: action.payload?.applicationName,
                    reportMode: "edit",
                    isLatestVersion: true,
                },
                loading: false,
                isReportCreated: true,
                error: false,
                errorMessage: ''
            }
        case "UPDATE_REPORT_STARTED":

          return { ...state, loading: true, error: false, errorMessage: "" };
        case "UPDATE_REPORT_COMPLETED":
          return {
            ...state,
            reportInfo: {
              reportId: action.payload?.report_id,
              reportName: action.payload?.reportName,
              clientName: action.payload?.clientName,
              applicationName: action.payload?.clientName,
              reportMode: "edit",
              isLatestVersion: true,
            },
            loading: false,
            isReportCreated: true,
            error: false,
            errorMessage: "",
            isEdit: false,
          };
          case 'UPDATE_REPORT_ERROR':
            return { ...state, error: true,errorMessage:action.payload, loading: false };
          case "RESET_REPORT_INFO":
            return {
              ...state,
              reportInfo: {
                reportId: null,
                reportName: null,
                clientName: null,
                applicationName: null,
                reportMode: "edit",
                isLatestVersion: true,
              },
              loading: false,
              isReportCreated: false,
              isEdit: false,
              isReportLoaded: false,
            };
          case "BACK_ACTION":
            return {
              ...state,
              loading: false,
              isReportCreated: false,
              isEdit: true,
              error: false,
              errorMessage: "",
            };
        case 'CREATE_REPORT_ERROR':
            return { ...state, error: true,errorMessage:action.payload, loading: false };
        case 'CREATE_FINDING_STARTED':
            return { ...state, loading: true , isFindingCreated: false};
        case 'CREATE_FINDING_COMPLETED': 
            const newFinding = {
                finding: `Finding ${state.findings?.length + 1}`,
                finding_id: action.payload.finding_id,
                status: 'New',
                vul_category: '',
                vul_name: {},
                vul_desc: '',
                vul_assets_impacted: '',
                vul_impact: '',
                vul_likelyhood_desc: '',
                steps: []
            }
            return {...state, 
                findings: [...state.findings, newFinding],
                loading: false,
                isFindingCreated: true
            }
        case 'CREATE_FINDING_ERROR':
            return { ...state, error: true, loading: false, isFindingCreated: false };
        case 'DELETE_FINDING_STARTED':
            return { ...state, loading: true , isFindingDeleted: false};
        case 'DELETE_FINDING_COMPLETED': 
            return {
                ...state, 
                findings: state.findings.filter((item: any) => item.finding_id !== action.payload.finding_id),
                loading: false,
                isFindingDeleted: true
            }
        case 'DELETE_FINDING_ERROR':
            return { ...state, error: true, loading: false, isFindingDeleted: false };
        case 'ADD_VULNAME_STARTED':
            return { ...state, loading: true , isVulNameAdded: false};
        case 'ADD_VULNAME_COMPLETED': 
            return {...state, 
                loading: false,
                isVulNameAdded: true,
                // vul_name_list: { ...state.vul_name_list, [action?.payload?.vul_name] :  [...state.vul_name_list, action.payload.vul_name]}
            }
        case 'ADD_VULNAME_ERROR':
                return { ...state, error: true, loading: false, isVulNameAdded: false };
        case 'GET_VUL_CAT_STARTED':
            return { ...state, loading: true , isGetVulCatLoaded: false};
        case 'GET_VUL_CAT_COMPLETED': 
            const vulCatList = JSON.parse(action.payload).map((item: any) => item.Category)
            return {...state, 
                loading: false,
                isGetVulCatLoaded: true,
                vul_category_list: vulCatList
            }
        case 'GET_VUL_CAT_ERROR':
                return { ...state, error: true, loading: false, isGetVulCatLoaded: false };
        case 'GET_VULNAME_STARTED':
            return { ...state, loading: true , isGETVulNameLoaded: false};
        case 'GET_VULNAME_COMPLETED': 
            return {...state, 
                loading: false,
                isGETVulNameLoaded: true,
                vul_name_list: { ...state.vul_name_list,  [action.payload.vul_category] : action.payload.vul_name_list.map((item: any) => item.Name) }
            }
        case 'GET_VULNAME_ERROR':
                return { ...state, error: true, loading: false, isGETVulNameLoaded: false };
        case 'GENERATE_FINDING_STARTED':
            return { ...state, loading: true , isFindingGenerated: false};
        case 'GENERATE_FINDING_COMPLETED': 
            return {...state, 
                loading: false,
                isFindingGenerated: true,
                findings: state.findings.map((item: any) => {
                    if (item.finding_id === action.payload.finding_id) {
                        return {
                            ...item,
                            ...action.payload,
                            status: 'Completed',
                            isLoaded: true,
                            aiGeneratedContent: action.payload
                        };
                    }
                    return item;
                })
            }
        case 'GENERATE_FINDING_ERROR':
                return { ...state, error: true, loading: false, isFindingGenerated: false };
        case 'ADD_STEP_STARTED':
            return { ...state, loading: true};
        case 'ADD_STEP_COMPLETED': 
            const mimeType = getMimeTypeFromFileName(action.payload.image_label);
            const file = decodeBase64ToFile(action.payload.encoded_image, action.payload.image_label, mimeType);
            const stepData = {
                ...action.payload,
                file: {
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    lastModified: file.lastModified,
                    webkitRelativePath: file.webkitRelativePath,
                },
            }
            return {
                ...state, 
                loading: false,
                findings: state.findings.map((item: any) => {
                    if (item.finding_id === action.payload.findings_id) {
                        return {
                            ...item,
                            steps: [
                                ...item.steps,
                                stepData
                            ],
                            StepsFollowedList: [
                                ...item.steps,
                                stepData
                            ],
                        };
                    }
                    return item;
                })
            }
        case 'ADD_STEP_ERROR':
            return { ...state, error: true, loading: false };
        case 'UPDATE_STEP_STARTED':
            return { ...state, loading: true};
        case 'UPDATE_STEP_COMPLETED': 
            return {
                ...state,
                loading: false,
                findings: state.findings.map((item: any) => {
                    if (item.finding_id === action.payload.finding_id) {
                        return {
                            ...item,
                            steps: item.steps.map((step: any) =>
                                step.step_id === action.payload.step_id
                                    ? { ...step, ...action.payload}
                                    : step
                            ),
                            StepsFollowedList: item.StepsFollowedList
                                ? item.StepsFollowedList.map((step: any) =>
                                    step.step_id === action.payload.step_id
                                        ? { ...step, ...action.payload }
                                        : step
                                )
                                : [],
                        };
                    }
                    return item;
                }),
            }
        case 'UPDATE_STEP_ERROR':
            return { ...state, error: true, loading: false };
        case 'SAVE_REPORT_STARTED':
            return { ...state, loading: true };
        case 'SAVE_REPORT_COMPLETED': 
            const { FindingsList } = action.payload;
            const updatedFindings = state.findings.map((finding: any) => {
                const matchedFinding = FindingsList?.find(
                    (f: any) => f.finding_id === finding.finding_id
                );
                if (matchedFinding && matchedFinding.FindingName) {
                    let normalizedSteps = finding.steps;
                    try {
                        const isGroupedAiaSteps =
                            Array.isArray(matchedFinding.StepsFollowedList) &&
                            matchedFinding.StepsFollowedList.length > 0 &&
                            Array.isArray(matchedFinding.StepsFollowedList[0]?.steps);
                        normalizedSteps = formatSteps(
                            matchedFinding.StepsFollowedList || [],
                            isGroupedAiaSteps
                        );
                    } catch (e) {
                        normalizedSteps = finding.steps;
                    }
                    return {
                        ...finding,
                         vul_category: matchedFinding.Category,
                              vul_name: matchedFinding.FindingName,
                              vul_desc: matchedFinding.Description,
                              vul_assets_impacted: matchedFinding.ImpactedAssets,
                              vul_impact: matchedFinding.Impact,
                              vul_likelyhood_desc: matchedFinding.LikelyhoodDescription,
                              steps: normalizedSteps,
                              isSavedInReport: true,
                              isModified: false,
                              aiGeneratedContent: {
                                cvss_vector: matchedFinding.CVSSVectorString,
                                cvss_score: matchedFinding.CVSSScore,
                                cvss_severity: matchedFinding.Severity,
                                likelihood: matchedFinding.Likelyhood,
                                recommendation: matchedFinding.Recommendation,
                                priority: matchedFinding.Priority,
                                complexity: matchedFinding.Complexity,
                                references: matchedFinding.ReferenceURLs,
                                cvssValidation: false, // need to check,
                                baseline_cvss_vector: matchedFinding.BaseLineCVSSVectorString
                              }
                    };
                }
                return finding;
            });
            return { ...state, 
                loading: false,
                findings: state.isVulCategoryNameChanged ? state.findings: updatedFindings,                
            }
        case 'SAVE_REPORT_ERROR':
                return { ...state, error: true, loading: false };
        case "SET_IS_VUL_NAME_CATEGORY_CHANGED":
            return { ...state, isVulCategoryNameChanged: action.payload };
        case 'GENERATE_REPORT_STARTED':
            return { ...state, loading: true, errorGenerateReport: false, isReportGenerated: false };
        case 'GENERATE_REPORT_COMPLETED':
            return { ...state,
                loading: false,
                errorGenerateReport: false,
                isReportGenerated: true
            }
        case 'GENERATE_REPORT_ERROR':
                return { ...state, errorGenerateReport: true, loading: false };
        case 'GET_REPORT_BY_ID_STARTED':
            return { ...state, loading: true };
        case 'GET_REPORT_BY_ID_COMPLETED':
            let report= action.payload;
            return { 
                ...state, 
                findings: report.findings ??[], 
                editReport: report.findings,
                isReportLoaded : true,
                reportInfo: {
                    reportId: report.ReportId,
                    reportName: report.ReportName,
                    clientName: report.ClientName,
                    applicationName: report.ApplicationName,
                    dateRange: report.dateRange,
                    ReportFileName: report.ReportFileName,
                    reportMode: report.reportMode || "edit",
                    isLatestVersion: report.isLatestVersion !== false,
                    versionId: report.versionId || undefined,
                },
                isReportGenerated:true,
                isReportCreated: true,
                isFindingCreated: true,
                loading: false
            };
        case 'GET_REPORT_BY_ID_ERROR':
            return { ...state, error: true, loading: false };
        case "DELETE_STEP_UPLOAD_IMAGE_STARTED":
            return { ...state, loading: true, stepUploadError: false };
        case "DELETE_STEP_UPLOAD_IMAGE_COMPLETED":
            return { ...state, loading: false, 
                stepUploadError: false,
                findings: state.findings.map((item: any) => {
                    if (item.finding_id === action.payload.finding_id) {
                        return {
                            ...item,
                            steps: item.steps.map((step: any) => {
                                if (step.step_id === action.payload.step_id) {
                                    const { encoded_image, image_link, image_label, ...rest }  = step
                                    return {
                                        ...rest,
                                        file: null,

                                    };
                                }
                                return step;
                            }),
                            StepsFollowedList: item.StepsFollowedList.map((step: any) => {
                                if (step.step_id === action.payload.step_id) {
                                    const { encoded_image, image_link, image_label, ...rest }  = step
                                    return {
                                        ...rest,
                                        file: null,
                                    };
                                }
                                return step;
                            }),
                        };
                    }
                    return item;
                }),
            };
        case "DELETE_STEP_UPLOAD_IMAGE_ERROR":
            return { ...state, loading: false, stepUploadError: true };
        case "DELETE_STEP_STARTED":
            return { ...state, loading: true , stepDeleteError: false };
        case "DELETE_STEP_COMPLETED":
            const { finding_id, step_id } = action.payload;
            return {
                ...state,
                findings: state.findings.map((item: any) => {
                    if (item.finding_id === finding_id) {
                        return {
                            ...item,
                            steps: item.steps.filter((step: any) => step.step_id !== step_id),
                            StepsFollowedList: item.StepsFollowedList.filter((step: any) => step.step_id !== step_id),
                        };
                    }
                    return item;
                }),
                loading: false,
                stepDeletedError: false,
            };
        case "DELETE_STEP_ERROR":
            return { ...state, loading: false, stepDeleteError: true};
        default:
            return state;
    }
}

export default sideBarReducer;